import styled from 'styled-components';
import GuidePao from '@/assets/guide/guide-pao.png';

export const GuideOverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  pointer-events: auto;
`;

export const Mask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(1px);
`;

export const GuideWindow = styled.div.withConfig({
  shouldForwardProp: prop => !['customTop', 'customLeft', 'targetPosition'].includes(prop),
})<{
  customTop?: number | string;
  customLeft?: number | string;
}>`
  position: absolute;
  background: #1a1a1a;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  max-width: 400px;
  min-width: 190px;
  pointer-events: auto;
  box-shadow: 3px 3px 8px 3px rgba(255, 109, 73, 0.1);
  border: Mixed solid rgba(255, 255, 255, 0.08);

  ${({ customTop, customLeft }) => {
    // 如果指定了自定义的 top 和 left，优先使用
    if (customTop !== undefined || customLeft !== undefined) {
      return `
        top: ${customTop !== undefined ? `${Number(customTop)}px` : '50%'};
        left: ${customLeft !== undefined ? `${Number(customLeft) - 20}px` : '50%'};
      `;
    } else {
      return `
        top: 50%;
        left: 50%;
      `;
    }
  }}
`;

export const GuideContent = styled.div`
  position: relative;
  width: 100%;
`;

export const GuideImage = styled.img`
  // height: auto;
  border-radius: 12px;
  object-fit: cover;
  width: 160px;
  height: 199px
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

export const GuideImageContainer = styled.div`
  margin-bottom: 16px;
  text-align: center;
  margin: 0 18px;
  height: 199px;
`;

export const GuideIndicator = styled.div.withConfig({
  shouldForwardProp: prop => !['guidePosition'].includes(prop),
})<{
  position: 'left' | 'right' | 'top' | 'bottom';
  guidePosition: { top: number; left: number };
}>`
  position: absolute;
  z-index: 1002;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 20px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  animation: pulse 2s infinite;
  pointer-events: none;

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.05);
    }
    100% {
      transform: scale(1);
    }
  }

  ${({ position, guidePosition }) => {
    const { top, left } = guidePosition;

    switch (position) {
      case 'left':
        return `
          top: ${top}px;
          left: ${left - 100}px;
          transform: translateY(-50%);
        `;
      case 'right':
        return `
          top: ${top}px;
          left: ${left + 400}px;
          transform: translateY(-50%);
        `;
      case 'top':
        return `
          top: ${top - 60}px;
          left: ${left}px;
          transform: translateX(-50%);
        `;
      case 'bottom':
        return `
          top: ${top + 300}px;
          left: ${left}px;
          transform: translateX(-50%);
        `;
      default:
        return `
          top: ${top}px;
          left: ${left - 100}px;
          transform: translateY(-50%);
        `;
    }
  }}
`;

export const IndicatorIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 16px;
`;

export const IndicatorImage = styled.div`
  width: 60px;
  height: 60px;
`;

export const IndicatorTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 68px;
  height: 68px;
  text-align: center;
  justify-content: center;
  background-image: url(${GuidePao});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  background-color: transparent;
`;

export const IndicatorText = styled.span`
  white-space: nowrap;
  padding-right: 5px;
  font-size: 16px;
  color: #fff;
`;

export const GuideHeader = styled.div`
  padding: 18px 0 14px;

  div {
    margin: 0;
    padding-left: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    gap: 6px;
    color: #fff;
    font-size: 16px;
  }
`;

export const GuideFooter = styled.div`
  padding: 14px 18px 18px;
`;

export const StepIndicator = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: #999;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 1;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    color: #fff;
  }
`;

export const NavigationButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
